interface BadgeProps {
  text: string;
  bgColour: string;
  textColour: string;
  ringColour: string;
  icon?: React.ReactNode | null;
}

export default function Badge({
  text,
  bgColour,
  textColour,
  ringColour,
  icon,
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full bg-${bgColour}/20 px-2 py-1 text-xs font-medium text-${textColour} ring-1 ring-inset ring-${ringColour}/30 whitespace-nowrap`}
    >
      {icon !== null && icon}
      {text}
    </span>
  );
}

Badge.defaultProps = {
  icon: null,
};
